import * as SwitchPrimitives from '@radix-ui/react-switch';

type BillingSwitchProps = {
  id: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
};

export const BillingSwitch = ({ id, checked, onCheckedChange }: BillingSwitchProps) => (
  <SwitchPrimitives.Root
    id={id}
    checked={checked}
    onCheckedChange={onCheckedChange}
    className='inline-flex h-[30px] w-[52px] shrink-0 cursor-pointer items-center rounded-full border border-ob-border bg-ob-shell p-[3px] transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ob-focus focus-visible:ring-offset-2 focus-visible:ring-offset-ob-canvas data-[state=checked]:border-ob-primary data-[state=checked]:bg-ob-primary'
  >
    <SwitchPrimitives.Thumb className='pointer-events-none block h-[22px] w-[22px] rounded-full bg-[#d9dce2] transition-transform duration-200 data-[state=checked]:translate-x-[22px] data-[state=checked]:bg-white' />
  </SwitchPrimitives.Root>
);
